// A proposal changes a copy of the agreed sectors; the baseline never changes.
export function proposalChanges(baseline = [], selected = []) {
  const current = new Set(baseline);
  const proposed = new Set(selected);
  return {
    baseline: [...current],
    removed: [...current].filter((s) => !proposed.has(s)),
    added: [...proposed].filter((s) => !current.has(s)),
  };
}

export function editProposalSector(selected, baseline, sector, mode) {
  const current = new Set(baseline);
  const next = new Set(selected);
  if (mode === "remove" && current.has(sector)) {
    if (next.has(sector)) next.delete(sector); else next.add(sector);
  } else if (mode === "add" && !current.has(sector)) {
    if (next.has(sector)) next.delete(sector); else next.add(sector);
  } else if (mode === "undo") {
    if (current.has(sector)) next.add(sector); else next.delete(sector);
  }
  return [...next];
}

export function proposalTotals(changes, perSector = {}) {
  const sum = (sectors) => sectors.reduce((n, s) => n + (perSector[s] || 0), 0);
  const current = sum(changes.baseline);
  const removed = sum(changes.removed);
  const added = sum(changes.added);
  return { current, removed, added, proposed: current - removed + added };
}
